import React, {ReactNode} from 'react'

import {FormControl, FormHelperText, InputLabel, Select} from "@material-ui/core";
import clsx from "clsx";

interface MaterialSelectorProps {
    id?: string
    name: string
    label: string
    value?: string | number
    className?: string
    errorMessage?: string
    children: ReactNode
    defaultValue?: string | number
    onChange?: (e: any) => void
    onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
    disabled?: boolean
    focused?: boolean
}

const MaterialSelector = ({ className, errorMessage, label, id, name, children, focused, disabled, value, ...props}: MaterialSelectorProps) => {
    return (
        <FormControl disabled={disabled} variant="outlined" fullWidth error={!!errorMessage} focused={focused}>
            <InputLabel>{label}</InputLabel>
            <Select
                className={clsx('no-fastclick', className)}
                style={{borderRadius: '0.5rem'}}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    getContentAnchorEl: null
                }}
                SelectDisplayProps={{ style: { display: 'flex', alignItems: 'baseline', borderRadius: '0.5rem', whiteSpace: 'break-spaces' } }}
                name={name}
                id={id}
                value={value}
                label={label}
                {...props}
            >
                {children}
            </Select>
            <FormHelperText>{!!errorMessage && errorMessage}</FormHelperText>
        </FormControl>
    )
}

export default MaterialSelector
